




























































import { computed, defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { Ref } from '@vue/composition-api'
import { formFieldProps } from '~/constants/form'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { useDeps } from '~/compositions/dependency-container'
import ScrollService from '~/services/scroll/ScrollService'

export default defineComponent({
  components: { FieldError },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)

    const value = ref<string[]>([])
    const showMobileMore = ref(false)
    const extrasRef = ref<HTMLElement>(null)

    function onValue(v: Ref<string[]>) {
      value.value = v.value || []
    }

    const [scrollService] = useDeps(ScrollService)

    const { error, valueChanged } = useClassifiedForm(props, { onValue })

    const options = computed(() => specs.value?.values || [])

    const groupedOptions = computed(() => {
      // Calculate the base index for each group
      const groupLimit = Math.floor(options.value.length / 3)

      const groups = Array.from({ length: 3 }, () => [])

      // if theres is a remainder then we add 1 to each column no matter what
      // case 1 = we add 1 to first and second col (and 3rd has -2)
      // case 2 = we add 1 to first and second col (and 3rd has -1)
      // case 3 = impossible, it will be 3 % 3 = 0
      let extra = options.value.length % 3 ? 1 : 0

      for (let i = 0; i < options.value.length; i++) {
        const groupIndex = Math.floor(i / (groupLimit + extra))

        if (groupIndex === 2 && extra % 3 !== 0) {
          extra = 0 // last column should not have any extras
        }

        if (!groups[groupIndex]) {
          groups[2].push(options.value[i])
          continue
        }
        groups[groupIndex].push(options.value[i])
      }

      return groups
    })
    const handleExtrasChange = (v: string[]) => {
      valueChanged(name.value, v)
    }

    const mobileOptionsToShow = computed(() => {
      if (showMobileMore.value) {
        return options.value
      }

      return [...options.value.slice(0, 20)] // first 10 lines
    })

    const toggleShowMobile = (e: Event) => {
      if (e.target) {
        e.target.blur()
      }
      showMobileMore.value = !showMobileMore.value

      if (showMobileMore.value === false && extrasRef.value) {
        // we just closed it so scroll it back into view
        scrollService.scrollTo(extrasRef.value, {
          easing: 'ease-out',
          offset: -120,
          duration: 0
        })
      }
    }

    return {
      value,
      error,
      groupedOptions,
      handleExtrasChange,
      options,
      showMobileMore,
      toggleShowMobile,
      mobileOptionsToShow,
      extrasRef
    }
  }
})
